import { useEffect, useState } from "react";
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import AlertMessage from "../include/AlertMessage";
import ConfirmationPopup from "../include/ConfirmationPopup"; // ⬅️ Import new popup
import Pagination from "../Pagination";

var _ = require('lodash');

function Categories() {
  const [allCategories, setallCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = sessionStorage.getItem('JWT_TOKEN');
  const location = useLocation();
  const [alert, setAlert] = useState({ type: "", message: "" });
  const [showPopup, setShowPopup] = useState(false); // popup state
  const [deleteId, setDeleteId] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCategories, setTotalCategories] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  const currentPage = Number(searchParams.get("page")) || 1;

  const LIMIT = 10;


  const fetchCategories = async (page = currentPage) => {
    setLoading(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/categories`, {
        params: {
          latitude: 0,
          longitude: 0,
          radius: 0,
          page,
          limit: LIMIT
        },
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token // Replace with your token
        }
      });

      const data = response.data?.documents || [];
      if (Array.isArray(data) && data.length > 0) {
        setallCategories(data);
        //setCurrentPage(response.data.pagination.page);
        setTotalPages(response.data.pagination.totalPages);
        setTotalCategories(response.data.pagination.total);
      } else {
        setallCategories([]);
      }
    } catch (err) {
      const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Something went wrong");
      setAlert({ type: "error", message: apierror });
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  useEffect(() => {
    document.documentElement.className = "";

    fetchCategories(currentPage);
  }, [currentPage]);

  const handleDelete = async (id) => {
    if (!deleteId) return;
    try {
      setDeleting(true);
      const response = await axios.delete(`${process.env.REACT_APP_API_URL}/deletecategory/${deleteId}`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token // Replace with your token
          }
        }
      );

      if (response.status === 200 || response.status === 201) {
        const updatedData = allCategories.filter(category => category.$id !== deleteId);

        setallCategories(updatedData);

        setAlert({ type: "success", message: "Category deleted successfully!" });

        // ⭐ If page becomes empty go to previous page
        if (updatedData.length === 0 && currentPage > 1) {
          setSearchParams({
            page: currentPage - 1
          });
        }
      }
    } catch (err) {
      const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Something went wrong");
      setAlert({ type: "error", message: apierror });
    } finally {
      setShowPopup(false); // close popup after action
      setDeleteId(null); // reset id
      setDeleting(false);
    }
  };

  //const visiblePages = getPagination(currentPage, totalPages);

  return (
    <section>
      <div className="is-title-bar">
        <div className="flex flex-col md:flex-row items-center justify-between space-y-6 md:space-y-0">
          <ul>
            <li><Link to="/dashboard" className='btn btn-primary'>Dashboard</Link></li>
            <li>Categories</li>
          </ul>
          <Link to="/category/add" className='button blue'>Add Category</Link>
        </div>
      </div>
      <div className="section main-section">
        <div className="grid gap-6 grid-cols-1 md:grid-cols-12">
          <div className="card">
            <header className="card-header">
              <p className="card-header-title">
                <span className="icon"><i className="mdi mdi-reorder-horizontal"></i></span>
                Categories
              </p>
            </header>
            <div className="card-content">
              {alert.message && (
                <AlertMessage
                  type={alert.type}
                  message={alert.message}
                  onClose={() => setAlert({ type: "", message: "" })}
                  duration={3000}
                />
              )}
              {loading ? (
                <div className="flex justify-center items-center py-10">
                  <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500 border-solid"></div>
                </div>

              ) : (
                Array.isArray(allCategories) && allCategories.length > 0 ? (
                  <>
                    <table>
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {(allCategories || []).map((item, index) => (
                          <tr key={item.$id}>
                            <td data-label="name">{item.name}</td>
                            <td className="actions-cell">
                              <div className="buttons right nowrap">
                                <Link to={`/category/edit/${item.$id}?page=${currentPage}`} className='button small green'> <span className="icon"><i className="mdi mdi-lead-pencil"></i></span></Link>
                                <button
                                  className="button small red"
                                  type="button"
                                  onClick={() => {
                                    if (deleting) return;
                                    setDeleteId(item.$id);
                                    setShowPopup(true);
                                  }}
                                  style={{
                                    cursor: deleting ? "not-allowed" : "pointer",
                                    opacity: deleting ? 0.5 : 1
                                  }}
                                >
                                  <span className="icon"><i className="mdi mdi-trash-can"></i></span>
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {totalPages > 1 && (
                      <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        totalRecords={totalCategories}
                        onPageChange={(page) =>
                          setSearchParams({
                            page
                          })
                        }
                      />
                    )}
                  </>
                ) : (
                  <p style={{ color: 'red', fontWeight: 'bold', textAlign: 'center' }}>No Record Found.</p>
                )

              )}
            </div>
          </div>
        </div>
      </div>
      {/* Confirmation Popup */}
      <ConfirmationPopup
        show={showPopup}
        onConfirm={handleDelete}
        onCancel={() => {
          if (!deleting) {
            setShowPopup(false);
          }
        }}
        title="Confirm Delete"
        message={
          deleting
            ? "Deleting category..."
            : "Are you sure you want to delete this category?"
        }
        deleting={deleting}
      />
    </section >
  );
};

export default Categories;